export const recommendationsRoutes = {
  path: "/recommendations",
  children: [
    {
      index: true,
      async lazy() {
        const { Component, loader } = await import("./lazyRoute.ts");
        return { Component, loader };
      },
    },
    {
      path: "/recommendations/:id/accept",
      async lazy() {
        const { accept } = await import("./lazyRoute.ts");
        return { action: accept };
      },
    },
    {
      path: "/recommendations/:id/decline",
      async lazy() {
        const { decline } = await import("./lazyRoute.ts");
        return { action: decline };
      },
    },
    {
      path: "/recommendations/access-tokens/:token/accept",
      async lazy() {
        const { acceptTokenLoader, AcceptTokenComponent } = await import(
          "./lazyRoute.ts"
        );
        return { loader: acceptTokenLoader, Component: AcceptTokenComponent };
      },
    },
  ],
};
